import { useSelector } from "react-redux";
import {
  CompanyRoutes,
  EducationRoutes,
  SupplierRoutes,
  supplierSubscriptionRoute,
  WorkerRoutes,
} from "../routes";

const useRoleWiseRoutes = () => {
  const userData = useSelector((state) => state.userData.user);

  const getRoutesByRole = () => {
    if (userData?.role === "worker") return WorkerRoutes;
    if (userData?.role === "supplier" && userData?.subscriptionId !== null)
      return SupplierRoutes;
    if (userData?.role === "supplier" && userData?.subscriptionId === null)
      return supplierSubscriptionRoute;
    if (userData?.role === "company" && !userData?.userRole)
      return CompanyRoutes;
    if (userData?.role === "education") return EducationRoutes;
    if (userData?.role === "company" && userData?.userRole) {
      let ModifyRoutes = userData?.userRole?.pages.map((itemmmmm) => {
        let resultttt = CompanyRoutes.find(
          (nestedVal) => nestedVal.path == itemmmmm.path
        );
        return resultttt;
      });
      return ModifyRoutes;
    }
    return WorkerRoutes;
  };

  const routesToRender = getRoutesByRole();
  return { routesToRender };
};

export default useRoleWiseRoutes;
